import type { AiChatTimelineItem } from "@/lib/types/ai-chat";
import type { QueuedChatMessage } from "./useAiChatMessageQueue";

export function withPendingMessages(
  items: AiChatTimelineItem[],
  queued: QueuedChatMessage[],
) {
  const confirmed = new Set(
    items
      .filter((item) => item.kind === "user_message")
      .map((item) => item.payload.clientRequestId),
  );
  const sequence = items.at(-1)?.sequence ?? 0;
  return [
    ...items,
    ...queued
      .filter((message) => !confirmed.has(message.id))
      .map(
        (message, index): AiChatTimelineItem => ({
          id: `pending:${message.id}`,
          sequence: sequence + index + 1,
          revision: 0,
          kind: "user_message",
          status: message.status,
          text: message.text,
          payload: {
            clientRequestId: message.id,
            fileReferences: message.fileReferences ?? [],
          },
          hasBody: false,
          contentBytes: 0,
          occurredAt: "",
          runId: null,
          messageId: null,
          toolRunId: null,
          guardianReviewId: null,
        }),
      ),
  ];
}
